import React from 'react';
import 'font-awesome/css/font-awesome.min.css';
import { useLocale } from '../context/LocaleContext';
import { buildWhatsAppUrl } from '../data/clinicContact';
import './WhatsAppFab.css';

export default function WhatsAppFab() {
  const { t } = useLocale();
  const whatsappUrl = buildWhatsAppUrl(t('home.whatsappMsg'));

  return (
    <a
      className="whatsapp_fab"
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t('topbar.whatsappAria')}
    >
      <i className="fa-brands fa-whatsapp" aria-hidden="true" />
      <span className="whatsapp_fab_label">WhatsApp</span>
    </a>
  );
}
